import { render } from "./BannerList.vue?vue&type=template&id=1226dd3f&scoped=true"
import script from "./BannerList.vue?vue&type=script&lang=js"
export * from "./BannerList.vue?vue&type=script&lang=js"

import "./BannerList.vue?vue&type=style&index=0&id=1226dd3f&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1226dd3f"]])

export default __exports__